/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  PERMISSION_FETCH_REQUEST,
  PERMISSION_FETCH_REQUEST_SUCCESS,
  PERMISSION_FETCH_REQUEST_FAILURE,
  SINGLE_PERMISSION_FETCH_REQUEST,
  SINGLE_PERMISSION_FETCH_REQUEST_FAILURE,
  SINGLE_PERMISSION_FETCH_REQUEST_SUCCESS,
  CLEAN_PERMISSION_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const permissionReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case PERMISSION_FETCH_REQUEST:
    case SINGLE_PERMISSION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case PERMISSION_FETCH_REQUEST_SUCCESS:
    case SINGLE_PERMISSION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case PERMISSION_FETCH_REQUEST_FAILURE:
    case SINGLE_PERMISSION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CLEAN_PERMISSION_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
        payload: [],
      });

    default:
      return state;
  }
};

export default permissionReducer;
